import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconNightSlightlyCloudy: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M23.4705 55.0224C18.5341 55.7848 14.3572 58.805 12.0594 63.0233C7.11327 56.8048 4.85441 48.4771 6.56803 40.0604C9.37212 26.1083 22.0392 16.84 35.6703 18.1174C36.6731 18.2065 37.637 18.3748 38.6399 18.5828C39.7304 18.8006 40.7722 19.0977 41.814 19.4344C40.0127 20.2859 38.2991 21.3058 36.7997 22.5832C32.7883 25.8608 29.8187 30.495 28.7282 36.0203C27.8908 40.0604 28.144 44.0608 29.2734 47.7147C26.7711 49.5762 24.7557 52.131 23.4705 55.0224Z"
        fill="#D2D4DA"
      />
      <path
        d="M61.7422 66.4548L57.6984 66.3663L57.6092 62.3174C57.3911 54.2588 50.3342 47.6743 41.8204 47.6743C39.4317 47.6743 37.1818 48.2247 35.0906 49.1484C33.6831 49.7774 32.3649 50.6226 31.2152 51.6446C29.5997 53.0402 28.3211 54.7207 27.4291 56.6665L26.4478 58.7401L24.1881 59.0743C19.9757 59.7032 16.5662 62.4451 15.0795 66.0813C14.7822 66.7594 14.5245 67.5161 14.3956 68.2728C14.2668 68.9116 14.1875 69.5406 14.1875 70.2187C14.1875 76.4199 19.5099 81.4418 26.0217 81.4418H61.5638C65.905 81.4418 69.4433 78.1102 69.4433 73.9728C69.4433 69.914 65.9942 66.5432 61.7422 66.4548Z"
        fill="#D2E0FF"
      />
      <path
        d="M88.7353 45.4193L85.9603 45.3797L85.872 42.569C85.7445 36.9179 80.9004 32.3257 75.0463 32.3257C73.448 32.3257 71.8889 32.7117 70.4572 33.3451C68.143 34.404 66.2897 36.235 65.1914 38.6102L64.5639 40.0552L62.9655 40.263C59.5531 40.8172 56.8565 43.4498 56.2681 46.6762C56.1798 47.1414 56.1406 47.5669 56.1406 48.042C56.1406 48.5962 56.1798 49.101 56.3073 49.6156C56.729 51.5752 57.8665 53.228 59.4256 54.287C60.769 55.2668 62.4556 55.8606 64.2697 55.8606H88.5686C91.5594 55.8606 94.0011 53.5249 94.0011 50.635C94.0011 47.8441 91.6379 45.5084 88.7353 45.4193Z"
        fill="#D2E0FF"
      />
    </svg>
  )
}

export default WeatherIconNightSlightlyCloudy
